// extracted by mini-css-extract-plugin
export default {"Root":"routes_Root__85YYI","contentWrap":"routes_contentWrap__b9Lq4","burgerWrapper":"routes_burgerWrapper__MYQ5a","burgerLine":"routes_burgerLine__ztQ2G"};